import type { BaseUsecase } from '@usecases/base-usecase';
import type { Agent } from '@entities/user';
import type { BusAgentStatusListPayload } from '@main/event-listeners/payloads/bus-agent-list.payload';

export interface SyncAgentStatusRepository {
  updateAgents(agents: Agent[]): Promise<void>;
  getAgents(): Promise<Agent[]>;
}

export interface SyncAgentStatusEventPublisher {
  publish(from: number): Promise<void>;
}

export interface SyncAgentStatusUsecase
  extends BaseUsecase<BusAgentStatusListPayload, void> {
  run(req: BusAgentStatusListPayload): Promise<void>;
}

export class SyncAgentStatus implements SyncAgentStatusUsecase {
  constructor(private repository: SyncAgentStatusRepository) {}

  async run(payload: BusAgentStatusListPayload): Promise<void> {
    try {
      const agents = await this.repository.getAgents();
      const agentStatuses = Object.values(payload) || [];

      if (agents.length === 0) {
        return;
      }

      const updatedAgents = agents.map((agent) => {
        const statusEntry = agentStatuses.find(
          (agentStatus) =>
            String(agentStatus.userId).trim() === String(agent.ID).trim(),
        );
        return {
          ...agent,
          availabilityStatus: statusEntry
            ? statusEntry.status
            : agent.availabilityStatus,
        };
      });

      await this.repository.updateAgents(updatedAgents);
    } catch (error) {
      // Let the error propagate up to be handled by the controller
      throw error;
    }
  }
}
